@for (debtorForm of debtors.controls; track debtorForm; let i = $index) {
  <app-debtor-form
    [form]="$any(debtorForm)"
    [index]="i"
    [partyTypes]="partyTypes"
    [representativeTypes]="representativeTypes"
    [countries]="countries"
  ></app-debtor-form>
}
